import { type DrugKeyType, DrugKeys } from './util/config/constants';

export const LILLY_DIRECT_CLIENT_ID = 'lillydirect';

export const lillyPharmacy = {
    // @TODO: get from overrides
    name: 'LillyDirect Pharmacy',
    npi: '1912889320',
    ncpdp: '1574056',
};

export const drugDescriptionMinWidth = 200;
export const drugImageMaxWidth = 160;
export const drugImageMaxHeight = 90;

export const zepboundPenDrugKey = DrugKeys.ZepboundAutoinjector;
export const zepboundVialDrugKey = DrugKeys.ZepboundVial;
export const zepboundKwikpenDrugKey = DrugKeys.ZepboundKwikPen;
export const orfoDrugKey = DrugKeys.Orfo;

export const configuredDrugKeys: DrugKeyType[] = [
    zepboundPenDrugKey,
    zepboundVialDrugKey,
    zepboundKwikpenDrugKey,
    orfoDrugKey,
];

export const UNKNOWN_PRODUCT_NDC = '99999999999';
